// KBA Vehicle Segments helper — mirrors backend/vehicle_segments_bp.py
// Used for client-side auto-suggestion while user types make/model.

const SEGMENT_MAP = {
  // mini
  'smart|fortwo': 'mini', 'smart|forfour': 'mini',
  'fiat|500': 'mini', 'fiat|panda': 'mini',
  'vw|up': 'mini', 'volkswagen|up': 'mini',
  'toyota|aygo': 'mini', 'peugeot|108': 'mini',
  'citroen|c1': 'mini', 'hyundai|i10': 'mini', 'kia|picanto': 'mini',
  // klein
  'vw|polo': 'klein', 'volkswagen|polo': 'klein',
  'opel|corsa': 'klein', 'ford|fiesta': 'klein',
  'renault|clio': 'klein', 'peugeot|208': 'klein',
  'citroen|c3': 'klein', 'seat|ibiza': 'klein',
  'skoda|fabia': 'klein', 'mini|cooper': 'klein',
  'toyota|yaris': 'klein', 'hyundai|i20': 'klein',
  'mazda|2': 'klein', 'honda|jazz': 'klein',
  'nissan|micra': 'klein', 'dacia|sandero': 'klein',
  // kompakt
  'vw|golf': 'kompakt', 'volkswagen|golf': 'kompakt',
  'opel|astra': 'kompakt', 'ford|focus': 'kompakt',
  'toyota|corolla': 'kompakt', 'renault|megane': 'kompakt',
  'peugeot|308': 'kompakt', 'seat|leon': 'kompakt',
  'skoda|octavia': 'kompakt', 'audi|a3': 'kompakt',
  'bmw|1er': 'kompakt', 'mercedes|a-klasse': 'kompakt',
  'mercedes-benz|a-klasse': 'kompakt',
  'hyundai|i30': 'kompakt', 'mazda|3': 'kompakt',
  'honda|civic': 'kompakt', 'kia|ceed': 'kompakt',
  // mittel
  'vw|passat': 'mittel', 'volkswagen|passat': 'mittel',
  'bmw|3er': 'mittel', 'audi|a4': 'mittel',
  'mercedes|c-klasse': 'mittel', 'mercedes-benz|c-klasse': 'mittel',
  'skoda|superb': 'mittel', 'opel|insignia': 'mittel',
  'ford|mondeo': 'mittel', 'mazda|6': 'mittel',
  'peugeot|508': 'mittel', 'toyota|avensis': 'mittel',
  'volvo|s60': 'mittel', 'volvo|v60': 'mittel',
  // ober
  'bmw|5er': 'ober', 'audi|a6': 'ober',
  'mercedes|e-klasse': 'ober', 'mercedes-benz|e-klasse': 'ober',
  'volvo|s90': 'ober', 'volvo|v90': 'ober',
  'tesla|model 3': 'ober', 'lexus|es': 'ober', 'jaguar|xf': 'ober',
  // suv
  'vw|tiguan': 'suv', 'volkswagen|tiguan': 'suv',
  'vw|t-roc': 'suv', 'vw|t-cross': 'suv', 'vw|touareg': 'suv',
  'bmw|x1': 'suv', 'bmw|x3': 'suv', 'bmw|x5': 'suv', 'bmw|x6': 'suv',
  'audi|q3': 'suv', 'audi|q5': 'suv', 'audi|q7': 'suv',
  'mercedes|glc': 'suv', 'mercedes-benz|glc': 'suv',
  'mercedes|gle': 'suv', 'mercedes-benz|gle': 'suv',
  'mercedes|gla': 'suv', 'mercedes-benz|gla': 'suv',
  'porsche|macan': 'suv',
  'skoda|kodiaq': 'suv', 'skoda|karoq': 'suv',
  'seat|ateca': 'suv', 'seat|tarraco': 'suv',
  'opel|mokka': 'suv', 'opel|grandland': 'suv',
  'ford|kuga': 'suv', 'ford|puma': 'suv',
  'hyundai|tucson': 'suv', 'hyundai|santa fe': 'suv',
  'kia|sportage': 'suv', 'kia|sorento': 'suv',
  'mazda|cx-5': 'suv', 'mazda|cx-3': 'suv',
  'toyota|rav4': 'suv', 'toyota|c-hr': 'suv',
  'nissan|qashqai': 'suv', 'nissan|juke': 'suv',
  'volvo|xc40': 'suv', 'volvo|xc60': 'suv', 'volvo|xc90': 'suv',
  'dacia|duster': 'suv', 'jeep|compass': 'suv',
  'tesla|model y': 'suv',
  // van
  'vw|t6': 'van', 'vw|t5': 'van', 'vw|t7': 'van',
  'vw|caddy': 'van', 'vw|sharan': 'van',
  'mercedes|v-klasse': 'van', 'mercedes-benz|v-klasse': 'van',
  'mercedes|vito': 'van', 'mercedes-benz|vito': 'van',
  'ford|tourneo': 'van', 'ford|galaxy': 'van',
  'ford|s-max': 'van', 'ford|transit': 'van',
  'seat|alhambra': 'van', 'opel|zafira': 'van',
  'opel|vivaro': 'van', 'renault|trafic': 'van',
  'citroen|berlingo': 'van', 'peugeot|partner': 'van',
  // luxus
  'mercedes|s-klasse': 'luxus', 'mercedes-benz|s-klasse': 'luxus',
  'mercedes|maybach': 'luxus', 'mercedes-benz|maybach': 'luxus',
  'bmw|7er': 'luxus', 'bmw|8er': 'luxus',
  'audi|a8': 'luxus', 'audi|r8': 'luxus',
  'porsche|panamera': 'luxus', 'porsche|911': 'luxus',
  'porsche|taycan': 'luxus', 'porsche|cayenne': 'luxus',
  'tesla|model s': 'luxus', 'tesla|model x': 'luxus',
  'jaguar|xj': 'luxus', 'lexus|ls': 'luxus',
  'bentley|continental': 'luxus', 'rolls-royce|ghost': 'luxus',
  'maserati|ghibli': 'luxus',
};

export function detectSegment(make, model) {
  if (!make) return null;
  const m = (make || '').trim().toLowerCase();
  const md = (model || '').trim().toLowerCase();
  const exact = SEGMENT_MAP[`${m}|${md}`];
  if (exact) return exact;
  // partial model match
  for (const key of Object.keys(SEGMENT_MAP)) {
    const [mk, mdl] = key.split('|');
    if (mk === m && mdl && md.includes(mdl)) return SEGMENT_MAP[key];
  }
  return null;
}

export const SEGMENT_LABELS = {
  mini:    'Kleinstwagen',
  klein:   'Kleinwagen',
  kompakt: 'Kompaktklasse',
  mittel:  'Mittelklasse',
  ober:    'Oberklasse',
  suv:     'SUV',
  van:     'Van/Bus',
  luxus:   'Luxusklasse',
};

// Pretty-cased make names for the autocomplete datalist
const MAKE_LABELS = {
  vw: 'VW', volkswagen: 'Volkswagen', bmw: 'BMW', audi: 'Audi',
  mercedes: 'Mercedes', 'mercedes-benz': 'Mercedes-Benz',
  opel: 'Opel', ford: 'Ford', toyota: 'Toyota', renault: 'Renault',
  peugeot: 'Peugeot', citroen: 'Citroën', seat: 'SEAT', skoda: 'Škoda',
  hyundai: 'Hyundai', kia: 'Kia', mazda: 'Mazda', honda: 'Honda',
  nissan: 'Nissan', dacia: 'Dacia', volvo: 'Volvo', tesla: 'Tesla',
  lexus: 'Lexus', jaguar: 'Jaguar', mini: 'Mini', smart: 'smart',
  fiat: 'Fiat', porsche: 'Porsche', jeep: 'Jeep', bentley: 'Bentley',
  'rolls-royce': 'Rolls-Royce', maserati: 'Maserati',
};

function _prettyMake(slug) {
  return MAKE_LABELS[slug] || slug.charAt(0).toUpperCase() + slug.slice(1);
}

function _prettyModel(slug) {
  return slug.split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

/**
 * Returns sorted unique pretty-cased Makes (e.g. "BMW", "Mercedes-Benz").
 */
export function getAllMakes() {
  const slugs = new Set();
  for (const key of Object.keys(SEGMENT_MAP)) slugs.add(key.split('|')[0]);
  return Array.from(slugs).map(_prettyMake).sort();
}

/**
 * Returns sorted unique pretty-cased models for a given make.
 * `make` may be the slug or the pretty label.
 */
export function getModelsForMake(make) {
  if (!make) return [];
  const m = (make || '').trim().toLowerCase();
  const matches = new Set();
  for (const key of Object.keys(SEGMENT_MAP)) {
    const [mk, mdl] = key.split('|');
    if (mk === m || _prettyMake(mk).toLowerCase() === m) matches.add(mdl);
  }
  return Array.from(matches).map(_prettyModel).sort();
}
